import React, { FC } from 'react';

const IconDownLoad: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        d="M18.208,4 C18.691558,4 19.1111093,4.177776 19.4666667,4.53333333 C19.822224,4.88889067 20,5.30844203 20,5.792 L20,18.208 C20,18.691558 19.822224,19.1111093 19.4666667,19.4666667 C19.1111093,19.822224 18.691558,20 18.208,20 L5.792,20 C5.29421973,20 4.87111285,19.822224 4.52266667,19.4666667 C4.17422048,19.1111093 4,18.691558 4,18.208 L4,14.6666667 L5.792,14.6666667 L5.792,18.208 L18.208,18.208 L18.208,5.792 L5.792,5.792 L5.792,9.33333333 L4,9.33333333 L4,5.792 C4,5.30844203 4.17422048,4.88889067 4.52266667,4.53333333 C4.87111285,4.177776 5.29421973,4 5.792,4 L18.208,4 Z M11.5452931,8 L16,12 L11.5452931,16 L10.2877442,14.8708134 L12.5683837,12.784689 L4,12.784689 L4,11.215311 L12.5683837,11.215311 L10.2877442,9.1291866 L11.5452931,8 Z"
        transform="rotate(90 12 12)"
      />
    </svg>
  );
};

export default IconDownLoad;
